
import { Component, Vue, Prop } from 'vue-property-decorator'
const TypesMap = {
    1: '研究报告',
    2: '影响力周榜',
    3: '影响力月榜',
    4: '牛媒专访'
}

type TypeMap = 'data' | 'flow' | 'api'

/**
 * @prop value  表格数据
 * @emit delete 删除记录
 */
@Component({
    name: 'recruit-table'
})
export default class extends Vue {
    @Prop({ required: true }) private value!: any[]
    @Prop({ default: 'data' }) private type!: TypeMap
    @Prop({ required: true }) private pathName!: string

    private typeFormatter(row: any) {
        return Reflect.get(TypesMap, row.type)
    }

    private recommendFormatter(row: any) {
        return row.recommend ? '是' : '否'
    }

    private topFormatter(row: any) {
        return row.top ? '是' : '否'
    }
}
